'use client'
import React from 'react'
import Image from 'next/image'
import { home } from '@/helpers/content/id/home'
import { montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import Button from '@/components/Button/Button'
import wa from "@/assets/wa-outline.svg"
import dekstop from "@/assets/legalitation/legal-dekstop.png"
import tablet from "@/assets/legalitation/legal-tablet.png"
import { CheckIcon } from '@heroicons/react/24/outline'
import bgHero from "@/assets/reconciliation-automate/bg-hero.svg"
import hero from "@/assets/reconciliation-automate/hero.png"
import waBlack from "@/assets/bookeeping_page/wa-outline-black.svg"
import { t } from 'i18next'



export default function HomeSectionReconciliation({homeRef, moveToSection}) {
  return (
    <div ref={homeRef} className='flex overflow-hidden justify-center items-center max-w-[1280px] lg:container lg:mx-auto lg:flex-row flex-col w-full h-full relative'>
      <div className='absolute w-[100rem] h-[100rem] md:-bottom-[40rem] lg:w-full lg:h-full lg:-top-20 lg:bg-contain lg:object-contain'>
        <Image src={bgHero} />
      </div>
      <div className='flex lg:flex-row flex-col mx-auto w-full lg:w-full justify-between items-center h-full xl:container relative'>
          <div className={`flex px-4 py-6 md:py-6 lg:py-0 flex-col justify-center lg:px-0 xl:px-0 max-w-[840px] h-full`}>
              <p className={`${montserratSemibold.className} text-base-white rounded-full px-4 py-1 flex justify-center items-center w-fit h-fit bg-semantic-negative-500`}>
                {t('recon_home_badge_name')}
              </p>
              <h1 className={`${montserratSemibold.className} py-3 lg:py-6 md:py-6 text-gray-cool-700 -tracking-[1.2px] self-stretch md:leading-[95%] lg:leading-[95%] leading-[44px] text-[36px] lg:text-[60px] md:text-[60px]`}>
                {t('recon_home_title')}
              </h1>
              <h4 className={`${montserratNormal.className} w-full lg:w-[75%] text-xl leading-[30px] tracking-tight text-gray-cool-700`}>
                {t('recon_home_description')}
              </h4>
              <div className='flex w-full space-x-3 pt-6 lg:pt-12 md:py-12'>
                <Button onClick={() => moveToSection("contact")} className={`${montserratSemibold.className}  py-1 bg-blue-primary-500 rounded-md md:text-base text-[14px] hover:cursor-pointer hover:bg-blue-primary-600 text-base-white`}>
                  {t('recon_home_button_schedule')}
                </Button>
                <Button onClick={() => window.open(`https://api.whatsapp.com/send?phone=6281287889023&text=${encodeURIComponent(t('recon_whatsapp_link'))}`,"_blank")} className={`bg-base-white hover:bg-gray-cool-100 border-[1px] border-gray-cool-200 rounded-md text-base-black ${montserratSemibold.className}`}>
                  <div className='w-5 mr-3'>
                    <Image src={waBlack} />
                  </div>
                  {t('recon_home_button_contact')}
                </Button>
              </div>
          </div>
      </div>
      <div className={`relative w-full lg:w-[65rem] px-8 lg:px-0 right-3 lg:right-8 xl:right-0 flex justify-end h-full`}>
          <div className='md:hidden flex lg:hidden h-full'>
              <Image src={hero} />
          </div>
          <div className='md:flex hidden lg:hidden h-full'>
              <Image src={hero} />
          </div>
          <div className='md:hidden hidden lg:flex h-full'>
              <Image src={hero} />
          </div>
        </div>
    </div>
  )
}
